import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
import { HeroBlueprint } from './HeroBlueprint';
const problems = ['Outdated site', 'No leads coming in', 'Template ceiling', 'Weak on mobile', 'Unclear SEO', 'Ecommerce fees', 'Hard to update', 'Nothing connects'];
export function Hero() {
  return <section className="relative overflow-hidden bg-ink pt-8 lg:pt-14" data-id="element-188" data-mp="apl7wwiwntdo">
      <div className="absolute inset-0 bp opacity-90" aria-hidden="true" data-id="element-189" data-mp="5pqh0sz4r3sm" />
      <div className="absolute -right-52 -top-40 h-[46rem] w-[46rem] rounded-full bg-navy-700/35 blur-[130px]" aria-hidden="true" data-id="element-190" data-mp="5rtiqa9nald6" />
      <div className="absolute -left-40 top-1/2 h-[30rem] w-[30rem] rounded-full bg-forge-orange/[0.09] blur-[120px]" aria-hidden="true" data-id="element-191" data-mp="3rx6tt7nelnsg" />

      <div className="relative mx-auto max-w-8xl px-5 pb-12 sm:px-8 lg:px-10 lg:pb-16" data-id="element-192" data-mp="1v3vd1hxpy5eq">
        <div className="grid items-center gap-10 lg:grid-cols-12 lg:gap-10" data-id="element-193" data-mp="1q6loe4i5lxry">
          <div className="lg:col-span-5" data-id="element-194" data-mp="1mw2txb2byi5n">
            <motion.div initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.45
          }} className="inline-flex items-center gap-2.5 rounded-full border border-white/12 bg-white/[0.04] py-1.5 pl-1.5 pr-4" data-id="element-195" data-mp="1myfbhn46eqi6">
              <span className="rounded-full bg-forge-orange px-2.5 py-1 font-mono text-[9.5px] font-semibold uppercase tracking-[0.14em] text-ink" data-id="element-196" data-mp="1hzc6u3s3ymaq">
                Since 2002
              </span>
              <span className="text-[12.5px] font-medium text-mist-200" data-id="element-197" data-mp="2anzu24wf3lqx">1000+ websites launched, not one of them a template</span>
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.05
          }} className="mt-6 font-display text-[2rem] font-extrabold leading-[1.07] tracking-[-0.02em] text-white sm:text-[2.7rem] lg:text-[3.05rem]" data-id="element-198" data-mp="20v28fpw4pgo3">
              Your business isn&apos;t a template.
              <span className="mt-1.5 block text-forge-orange" data-id="element-199" data-mp="2y926mv2clawx">Your website shouldn&apos;t be one.</span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="mt-5 max-w-xl text-[15px] leading-relaxed text-mist-200 sm:text-[16px]" data-id="element-200" data-mp="2u65ikou1gmll">
              We map how your company actually works — how you quote, sell, schedule, and follow up — then build the website
              around it. Pages, lead paths, ecommerce, SEO structure, integrations, hosting, updates, and support, handled by
              us.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.15
          }} className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-201" data-mp="21jb2e44989dx">
              <Link to="/#get-started" className="group inline-flex items-center justify-center gap-2 rounded-xl bg-forge-orange px-6 py-3.5 text-[15px] font-bold text-ink shadow-ember transition-transform hover:-translate-y-0.5" data-id="element-202" data-mp="h10ig9axqfb6">
                Get Started
                <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-203" data-mp="3ph2c8h5awy3y" />
              </Link>
              <Link to="/#comparison" className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/18 px-6 py-3.5 text-[15px] font-semibold text-white transition-colors hover:border-forge-cyan/60 hover:bg-white/5" data-id="element-204" data-mp="3ugop2ph7wcc8">
                Template vs custom
              </Link>
            </motion.div>

            <div className="mt-7 flex items-start gap-2.5 text-[13px] text-mist-300" data-id="element-205" data-mp="3are9dbhh1re4">
              <ShieldCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forge-green" aria-hidden="true" data-id="element-206" data-mp="2rn1e773hsnrx" />
              Love your site or get your money back — 30-day money-back option.
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.12
        }} className="lg:col-span-7" data-id="element-207" data-mp="31dchqsj9kuya">
            <HeroBlueprint data-id="element-208" data-mp="3acr8zu7999ju" />
          </motion.div>
        </div>
      </div>

      {/* problems ticker — the reasons businesses call us */}
      <div className="relative border-y border-white/10 bg-navy-950/70 py-3" data-id="element-209" data-mp="35gsc1i7v2j7t">
        <div className="ticker flex w-max items-center" data-id="element-210" data-mp="3kbggct1izblu">
          {[...problems, ...problems].map((p, i) => <span key={`${p}-${i}`} className="flex items-center gap-6 whitespace-nowrap pr-6 font-mono text-[10.5px] uppercase tracking-[0.18em] text-mist-300" data-id="element-211" data-mp="3fasok55h2qqk" data-mpi={i}>
              {p}
              <span className="h-1 w-1 rotate-45 bg-forge-orange" aria-hidden="true" data-id="element-212" data-mp="gtnc1ig8i09" />
            </span>)}
        </div>
      </div>
    </section>;
}